
<mat-toolbar color="primary">
  <div class="nav mt-3 gap-4 grid-cols-12 container">
    <div class="iconmenu" id="toggle-sidebar" (click)="clickSideBar()">
      <img src="../../../assets/nft/iconmenusccoll.png" width="50" height="50" alt="">
    </div>
    <ul class="grid grid-cols-12 gap-4">
      <li class="col-span-4 cursor-pointer">
        <a class="text-white" (click)="dologout()">AGADEVIN</a>
        <button  *ngIf="logout" class="btn btn-outline-light ml-4">
          <span *ngIf="token" (click)="out()">Logout</span>
          <span *ngIf="!token" (click)="login()">Login</span>
        </button>
      </li>
      <li>
        <a class="text-white" routerLink="">
         Home
        </a>
       </li>
      <li>
       <a class="text-white" routerLink="about">
        about
       </a>
      </li>
      <li>
      <a class="text-white" routerLink="work">
        work
      </a>
      </li>
      <li>
        <a class="text-white" routerLink="course" href="">course</a>
      </li>
      <li>
        <a class="text-white" routerLink="places">map</a>
      </li>
      <li>
        <a class="text-white text-sm" routerLink="web-dark/{{dark}}">Web me AI</a>
      </li>
    </ul>
  </div>
</mat-toolbar>
